import cloneDeep from 'lodash/cloneDeep';
import { WIDGET_TYPE } from '@/components/vjsf/vjsf';
import BaseTemplate from '@/components/vjsf/templates/base-template';
import CompensationTemplate from '@/components/vjsf/templates/compensation-template';
import ContractTemplate from '@/components/vjsf/templates/contract-template';
import IncomeTemplate from '@/components/vjsf/templates/income-template';

export const always = (value) => () => value;

export const cond = (mappings) => {
  return (...args) => {
    const [, getter] = mappings.find(([predicate]) => predicate(...args));
    return getter;
  };
};

// TODO: неуверен что это должно лежать в конвертере,
// т.к. кажется неспецифичным именно для форм со старой схемой на в vjsf исполнении
export const getSubmitButtonName = () => '__submit';

// ресолв текстового значения 'ui:ObjectFieldTemplate' на Vue-компонент
export const setObjectTemplateComponents = (uiSchema) => {
  const componentsMap = {
    CompensationTemplate,
    ContractTemplate,
    IncomeTemplate,
    BaseTemplate
  };
  return postProcessUiSchema(uiSchema, (obj) => {
    const template = obj['ui:ObjectFieldTemplate'];
    if (template) {
      return {
        'ui:ObjectFieldTemplate': componentsMap[template] || template
      };
    }
  });
};

export const hideApiFields = (uiSchema) => {
  return postProcessUiSchema(uiSchema, (obj) => {
    if (obj['ui:options']?.editViaApiOnly) {
      return {
        'ui:widget': WIDGET_TYPE.HIDDEN
      };
    }
  });
};

function postProcessUiSchema(uiSchema, handler = (x) => x) {
  function recursiveFn(obj) {
    if (typeof obj === 'object' && obj && !Array.isArray(uiSchema)) {
      const entries = Object.entries(obj);
      const patch = handler(obj);
      patch && Object.assign(obj, patch);
      entries.forEach(([, value]) => {
        recursiveFn(value);
      });
    }
  }
  const result = cloneDeep(uiSchema);
  recursiveFn(result);
  return result;
}
